<template>
  <div class="v-container">
    <div class="loadding-spin" v-if="loading">
      <Circle4></Circle4>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="title-body">
          <h3>DANH SÁCH PHIẾU THANH TOÁN</h3>
          <div class="title-btn">
            <el-button @click="fn_tableShowFormSearch()" icon="el-icon-search"
              >ẩn/hiện tìm kiếm</el-button
            >
            <el-button
              v-if="
                this.$router.currentRoute.name ===
                'DanhSachPhieuThanhToanVietToc'
              "
              type="primary"
              @click="fn_themPhieuThanhToan()"
              icon="el-icon-circle-plus-outline"
              >thêm mới phiếu thanh toán</el-button
            >
          </div>
        </div>
        <div class="main-body">
          <div class="main-body-search mb-3">
            <b-collapse
              v-bind:visible="mData.tableRules.showFormSearch"
              id="myFormSearch"
              class="b-shadow"
            >
              <b-card style="min-height: auto">
                <el-form
                  ref="myForm"
                  label-position="top"
                  @submit.native.prevent
                  label-width="100px"
                  :model="mData.tableRules.dataSearch.value"
                  :rules="mData.tableRules.dataSearch.valid"
                >
                  <b-row>
                    <b-col md="3">
                      <el-form-item label="Kỳ thanh toán">
                        <el-date-picker
                          v-model="mData.ky_thanh_toan_str"
                          type="month"
                          format="MM-yyyy"
                          placeholder="Chọn kỳ thanh toán"
                        >
                        </el-date-picker>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item label="Đại lý">
                        <el-select
                          v-model="
                            mData.tableRules.dataSearch.value['dai_ly_id']
                          "
                          placeholder="Chọn đại lý"
                          loading-text="Đang tải dữ liệu"
                          clearable
                          filterable
                        >
                          <el-option
                            v-for="item in mData.listDaiLy"
                            :key="item.id"
                            :label="item.ten"
                            :value="item.id"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item label="Thời điểm tạo từ">
                        <el-date-picker
                          v-model="mData.tu_ngay"
                          type="date"
                          format="dd-MM-yyyy"
                          placeholder="Chọn thời gian"
                        >
                        </el-date-picker>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item label="Thời điểm tạo đến">
                        <el-date-picker
                          v-model="mData.den_ngay"
                          type="date"
                          format="dd-MM-yyyy"
                          placeholder="Chọn thời gian"
                        >
                        </el-date-picker>
                      </el-form-item>
                    </b-col>
                  </b-row>
                  <el-form-item class="text-center mb-0">
                    <el-button
                      icon="el-icon-search"
                      type="primary"
                      native-type="submit"
                      v-ladda
                      @click="fn_tableSearch()"
                      >Tìm kiếm</el-button
                    >
                  </el-form-item>
                </el-form>
              </b-card>
            </b-collapse>
          </div>
          <div class="main-body-table">
            <el-table
              stripe
              :data="mData.tableRules.data"
              border
              max-height="540"
              style="width: 100%"
              @sort-change="fn_tableSortChange"
              cell-class-name="cell-table"
              v-loading="loadingTable"
            >
              <el-table-column prop="" label="STT" width="50" fixed>
                <template slot-scope="scope">
                  <div class="text-center">
                    {{ mData.tableRules.offset + scope.$index + 1 }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                fixed
                prop="ten_dai_ly"
                label="Tên đại lý"
                min-width="150"
                align="center"
              >
                <template slot-scope="scope">
                  <router-link
                    :to="`/admin/dai-ly/chi-tiet/${scope.row.dai_ly_id}`"
                  >
                    {{ scope.row.ten_dai_ly }}
                  </router-link>
                </template>
              </el-table-column>
              <el-table-column
                prop="ky_thanh_toan_str"
                label="Kỳ thanh toán"
                width="150"
                align="center"
              >
              </el-table-column>
              <el-table-column
                label="Nội dung"
                prop="noi_dung"
                min-width="150"
                align="left"
              >
              </el-table-column>
              <el-table-column
                prop="thoi_diem_tao"
                label="Thời điểm tạo"
                align="center"
                width="170"
                :sortable="mData.tableRules.allowSorting"
              >
                <template slot-scope="scope">
                  {{ fn_formatDate(scope.row.thoi_diem_cap_nhat) }}
                </template>
              </el-table-column>
              <el-table-column
                label="Thao tác"
                align="center"
                width="150px"
                fixed="right"
              >
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    plain
                    @click="fn_handle('detail', scope.$index, scope.row)"
                    v-b-popover.hover.left="aLang.c_detail"
                  >
                    <i class="fa fa-eye"></i>
                  </el-button>
                  <el-button
                    v-if="
                      $router.currentRoute.name ===
                        'DanhSachPhieuThanhToanDaiLy' &&
                      !scope.row.show_button_xac_nhan
                    "
                    size="mini"
                    type="success"
                    plain
                    @click="fn_handle('accept', scope.$index, scope.row)"
                    v-b-popover.hover.left="aLang.c_accept"
                  >
                    <i class="fa-regular fa-check"></i>
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="mt-2 text-right" v-if="mData.tableRules.allowPaging">
              <el-pagination
                @size-change="fn_tableSizeChange"
                :page-sizes="mData.tableRules.lengthMenu"
                :page-size="mData.tableRules.limit"
                :current-page="mData.tableRules.page"
                @current-change="fn_tableCurentChange"
                @prev-click="fn_tablePrevClick"
                @next-click="fn_tableNextClick"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="mData.tableRules.total"
                :pager-count="5"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Circle4 } from "vue-loading-spinner";
import LanguageService from "@/service/LanguageService";
import MethodService from "@/service/MethodService";
import DataForm from "@/dataForm/dataFormPhieuThanhToan";
import mushroom from "viettoc-api";
export default {
  data() {
    return {
      aLang: LanguageService.lang,
      loading: true,
      loadingTable: false,
      currentRouteName: undefined,
      mData: {
        tableRules: MethodService.copyObject(DataForm.tableRules),
        listDaiLy: [],
        ky_thanh_toan_str: "",
        tu_ngay: "",
        den_ngay: "",
      },
    };
  },
  components: {
    Circle4,
  },
  methods: {
    fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        // this.mData.tableRules.page = parseInt(this.$route.query.page);
        this.mData.tableRules.page = this.$route.query.page;
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
      }
      if (this.$route.query.showFormSearch) {
        if (this.$route.query.showFormSearch == "true") {
          this.mData.tableRules.showFormSearch = true;
        } else this.mData.tableRules.showFormSearch = false;
      }
      setTimeout(() => {
        console.clear()
      }, 500);
    },
    fn_formatDate(date) {
      return MethodService.formatDate(date, "datetime");
    },
    async fn_getDaiLy() {
      const response = await mushroom.agt_dai_ly.getAllAsync({
        limit: 100,
        filters: ["loai_dong_tien=ve_viettoc"],
        fields: "id,ten",
      });
      if (response.result && response.result.length > 0) {
        this.mData.listDaiLy = response.result;
      }
    },

    async fn_initTable() {
      this.loadingTable = true;
      let dataFilter = {
        filters: this.fn_renderFilters(this.mData.tableRules.filters),
        fields: this.mData.tableRules.fields,
      };
      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }
      if (this.mData.tableRules.showUrl) {
        this.$router
          .replace({
            name:
              this.$router.currentRoute.name === "DanhSachPhieuThanhToanVietToc"
                ? "DanhSachPhieuThanhToanVietToc"
                : "DanhSachPhieuThanhToanDaiLy",
            query: {
              limit: this.mData.tableRules.limit,
              page: this.mData.tableRules.page,
              sort: this.mData.tableRules.sort,
              filters: this.mData.tableRules.filters,
              showFormSearch: this.mData.tableRules.showFormSearch,
            },
          })
          .catch((err) => {});
      }
      try {
        const response = await mushroom.pmt_dai_ly.listAsync(dataFilter, {
          enabledCache: false,
        });
        if (response.result) {
          let resData = await this.fn_changeData(response.result);
          this.mData.tableRules.data = resData;
          this.mData.tableRules.total = response.meta.total;
          this.mData.tableRules.page =
            response.meta.offset / response.meta.limit + 1;
        }
      } catch (e) {
        MethodService.showError(e.code);
      } finally {
        this.loadingTable = false;
        this.loading = false;
      }
    },
    async fn_changeData(data) {
      data.forEach((item) => {
        if (!item.vt_xac_nhan) {
          item.show_button_xac_nhan = false;
        } else item.show_button_xac_nhan = true;
        item.ky_thanh_toan_str = "";
        if (item.ky_thanh_toan) {
          if (item.ky_thanh_toan.thang && item.ky_thanh_toan.nam) {
            item.ky_thanh_toan_str =
              item.ky_thanh_toan.thang + "/" + item.ky_thanh_toan.nam;
          }
        }

        this.mData.listDaiLy.forEach((x) => {
          if (x.id === item.dai_ly_id) item.ten_dai_ly = x.ten;
        });
      });
      return data;
    },
    fn_themPhieuThanhToan() {
      this.$router.push({
        name: "ThemMoiPhieuThanhToan",
      });
    },
    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },
    async fn_handle(type, scope, row) {
      if (type == "detail") {
        this.$router.push({
          name: "ChiTietPhieuThanhToan",
          params: { id: row.id },
        });
      }
      if (type == "accept") {
        try {
          const response = await mushroom.pmt_dai_ly.xac_nhan_thanh_toanAsync({
            body: { id: row.id },
          });
          if (response.result) {
            window.toastr.success("Xác nhận phiếu thanh toán thành công");
            await this.fn_initTable();
          }
        } catch (error) {
          MethodService.showError(e.code);
        }
      }
    },
    fn_renderFilters(filters) {
      let filtersArray = [];
      this.$router.currentRoute.name === "DanhSachPhieuThanhToanVietToc"
        ? (filters += "&ben_thanh_toan=viettoc")
        : (filters += "&ben_thanh_toan=dai_ly");

      if (filters.length > 0) {
        let array = filters.split("&");
        array.forEach((item) => {
          filtersArray.push(item);
        });
      }
      return filtersArray;
    },
    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch =
        !this.mData.tableRules.showFormSearch;

      this.$router.replace({
        name:
          this.$router.currentRoute.name === "DanhSachPhieuThanhToanVietToc"
            ? "DanhSachPhieuThanhToanVietToc"
            : "DanhSachPhieuThanhToanDaiLy",
        query: {
          limit: this.mData.tableRules.limit,
          page: this.mData.tableRules.page,
          sort: this.mData.tableRules.sort,
          filters: this.mData.tableRules.filters,
          showFormSearch: this.mData.tableRules.showFormSearch,
        },
      });
      this.fn_initTable();
    },
    fn_tableSearch() {
      if (this.mData.ky_thanh_toan_str) {
        const date = new Date(this.mData.ky_thanh_toan_str);
        this.mData.tableRules.dataSearch.value["ky_thanh_toan.nam"] =
          date.getFullYear();
        this.mData.tableRules.dataSearch.value["ky_thanh_toan.thang"] =
          date.getMonth() + 1;
      }
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          this.loading = true;
          if (!this.mData.ky_thanh_toan_str) {
            this.mData.tableRules.dataSearch.value["ky_thanh_toan.nam"] = null;
            this.mData.tableRules.dataSearch.value["ky_thanh_toan.thang"] =
              null;
          }

          this.mData.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearch)
          );
          if (this.mData.tu_ngay) {
            console.log("this.mData.tu_ngay", this.mData.tu_ngay);
            this.mData.tableRules.filters +=
              "&thoi_diem_tao>" + MethodService.toIsoDate(this.mData.tu_ngay);
          }
          if (this.mData.den_ngay) {
            console.log("this.mData.tu_ngay", this.mData.tu_ngay);
            const date23h = new Date(
              new Date(this.mData.den_ngay).setHours(23, 59, 59)
            ).toISOString();

            this.mData.tableRules.filters +=
              "&thoi_diem_tao<=" + MethodService.toIsoDate(date23h);
          }
          console.log(
            "this.mData.tableRules.filters",
            this.mData.tableRules.filters
          );
          this.mData.tableRules.offset = 0;
          this.fn_initTable();
          MethodService.stopLadda();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    forceUpdateUI() {
      this.$forceUpdate();
    },
    // phân trang
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(1);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },
  },
  watch: {
    '$route'(to, from) {
      this.currentRouteName = to.name; // Update the currentRouteName when the route changes
    },
    async currentRouteName(newName, oldName) {
      // Handle the route name change
      if (!oldName) {
        await this.fn_hashUrl();
      } else {
        this.mData.tableRules = MethodService.copyObject(DataForm.tableRules)
      }
      await this.fn_getDaiLy();
      await this.fn_initTable();
    }
  },
  async created() {
    this.currentRouteName = this.$route.name;
  },
};
</script>
<style scoped lang="scss">
.card {
  min-height: 88vh;
}
.card-header {
  background-color: #fafafa;
  border: 1px solid rgba(26, 54, 126, 0.125);
  border-bottom: none;
  text-align: center;
}
</style>
